<template>
  <div class="noticeCom">
    <div v-if="!isCloseAlert && operatorNotice.status">
      <el-alert title="友情提示" type="info" :description="operatorNotice.notice" show-icon effect="dark" @close="closeAlert">
      </el-alert>
    </div>
  </div>
</template>

<script>
import { shopContractReminder } from "@/api/notice";
import Cookies from "js-cookie";

export default {
  name: "noticeCom",
  components: {},
  data () {
    return {
      userInfo: {},
      operatorNotice: {}, // 通知信息
      isCloseAlert: false, // 是否关闭了通知
      timer: null, // 定时器
      interval: 1800000, // 通知再次弹出时间间隔
      timerGetDateAgain: null, // 更新数据间隔
    };
  },
  created () {
    this.userInfo = JSON.parse(Cookies.get("JavaInfo"));
  },
  mounted () {
    this.handleOperatorNotice();

    this.timerGetDateAgain = setInterval(() => {
      this.handleOperatorNotice();
    }, 5000);
  },
  watch: {
    isCloseAlert: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.againOpenNotice();
        }
      },
    },
  },
  methods: {
    // 运营方通知
    handleOperatorNotice () {
      const params = {
        id: this.userInfo.id,
        shopId: this.userInfo.shopId,
      };
      shopContractReminder(params)
        .then((res) => {
          this.operatorNotice = res;
          if (!res.status) {
            clearInterval(this.timerGetDateAgain);
            this.timerGetDateAgain = null;
            this.timerGetDateAgain = setInterval(() => {
              this.handleOperatorNotice();
            }, this.interval);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 关闭通知回调
    closeAlert () {
      this.isCloseAlert = true;
      clearInterval(this.timerGetDateAgain);
      this.timerGetDateAgain = null;
    },

    // 手动打开通知
    againOpenNotice () {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.isCloseAlert = false;
        this.timerGetDateAgain = setInterval(() => {
          this.handleOperatorNotice();
        }, 5000);
      }, this.interval);
    },
  },
};
</script>

<style lang='scss' scoped>
</style>